import React from 'react';
import { Info } from 'lucide-react';

interface FootnoteListProps {
  footnotes: string[];
}

export function FootnoteList({ footnotes }: FootnoteListProps) {
  if (footnotes.length === 0) return null;
  return (
    <div className="border rounded-lg p-4 bg-muted/20 space-y-2">
      <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">Notes</div>
      {footnotes.map((fn, i) => (
        <div key={i} className="flex items-start gap-2 text-xs text-muted-foreground">
          <Info className="h-3.5 w-3.5 shrink-0 mt-px text-blue-400" />
          <span>{fn}</span>
        </div>
      ))}
    </div>
  );
}
